import React from "react";

const MobileConsent = () => {
  return <div>Consent for mobile</div>;
};

export default MobileConsent;
